var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buying-list-item__favorite",on:{"click":_vm.changeStatus}},[_c('i',{class:'fa ' + (this.favoriteId ? 'fa-heart' : 'fa-heart-o')}),_vm._v("\n    Избранное\n")])}
var staticRenderFns = []

export { render, staticRenderFns }